<template>
  <div class="container mb-5">
    <div class="row">
      <div class="col-12 col-md-3 sticky-md pr-lg-4 pr-xl-7">
        <div v-show="showFilters">
          <h5>Filter</h5>
          <div class="accordion">
            <template v-for="(filter, name) in filterList">
              <div v-if="filter.type === 'order'" class="accordion-item">
                <div id="'headingOrder">
                  <div class="mb-0">
                    <h6 class="accordion-title font-weight-bold position-relative mt-3" data-toggle="collapse"
                        data-target="#collapseOrder"
                        aria-expanded="true" aria-controls="collapseOrder" v-html="label.order.title">
                      <span class="icon-chevron-down float-right"></span>
                    </h6>
                  </div>
                </div>
                <div id="collapseOrder" class="collapse show" aria-labelledby="headingOrder">
                  <div class="form-check">
                    <input name="order"
                           type="radio"
                           id="orderscorde"
                           value="score"
                           v-model="orderBy">
                    <label @click="sortPosts" for="orderscorde" v-html="label.order.title_score"></label>
                  </div>
                  <div class="form-check">
                    <input name="order"
                           type="radio"
                           id="orderasc"
                           value="asc"
                           v-model="orderBy">
                    <label @click="sortPosts" for="orderasc" v-html="label.order.title_asc"></label>
                  </div>
                  <div class="form-check">
                    <input name="order"
                           type="radio"
                           id="orderdesc"
                           value="desc"
                           v-model="orderBy">
                    <label @click="sortPosts" for="orderdesc" v-html="label.order.title_desc"></label>
                  </div>
                </div>
              </div>
              <div v-else class="accordion-item">
                <div :id="'heading' + name">
                  <div class="mb-0">
                    <h6 class="accordion-title font-weight-bold position-relative mt-3" data-toggle="collapse"
                        v-html="filter.title"
                        :data-target="'#collapse' + name" aria-expanded="true" :aria-controls="'collapse' + name">
                      <span class="icon-chevron-down float-right"></span>
                    </h6>
                  </div>
                </div>
                <div :id="'collapse' + name" class="collapse show" :aria-labelledby="'heading'+name">
                  <filterlist :list="filter.items" :name="taxMapping[filter.type]"
                              :clearLabel="label.search.clear_filters"
                              :showMoreLabel="label.search.more_filters"
                              :showLessLabel="label.search.less_filters"
                              @filterChanged="changeFilterList">
                  </filterlist>
                </div>
              </div>
            </template>

          </div>
        </div>
      </div>

      <div class="col-12 col-md-9">
        <search class="mb-5 searchBar--offset"
                :search-in="searchIn"
                :reload="false"
                :placeholder-text="placeholderText"
                :query="query"
                :label="label.search"
                @postSearch="setNewPosts"
                @postError="showError">
        </search>

        <loader  v-if="loading" :loading="loading" :message="label.results.loading" class="position-relative jusitfy-content-center"></loader>

        <div v-if="filteredPosts.length > 0 || postLarge.length > 0">

          <template v-if="allowedPostTypes.length > 0" v-for="posttype in allowedPostTypes">
            <div v-if="!isShopSearch">

              <h5 v-show="countPosts(posttype.type) > 0" class="mb-3">
                <span
                  class="dot dot--medium rounded-circle d-inline-flex flex-wrap flex-column justify-content-center align-items-center text-center"
                  :class="posttype.dot.class"
                  v-html="posttype.dot.icon">
                </span>{{ posttype.name }}</h5>

              <div class="row">
                <template v-for="(post, index) in postsByType(posttype.type)">
                  <article v-if="index < posttype.load" class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3">
                    <post :post="post" :key="post.ID"></post>
                  </article>
                </template>
                <div v-if="posttype.load < countPosts(posttype.type)" class="container mt-0 mb-5">
                  <button @click.prevent="loadMore(posttype)" class="btn btn-link pl-0" v-html="label.results.more">
                  </button>
                </div>
              </div>
            </div>

            <div v-else>
              <div class="row">
                <div class="col-12 pb-2">
                  <h5 v-html="label.search.featured"></h5>
                </div>
                <article v-for="post in postLarge" class="col-12 col-sm-6 col-lg-4">
                  <post :post="post" :key="post.ID" :cardClass="'card--default'"></post>
                </article>
              </div>

              <div class="row my-3 searchBar--offset">
                <div class="col-12">
                  <hr/>
                </div>
              </div>

              <div class="row searchBar--offset">
                <article v-for="post in filteredPosts" v-if="post.meta.show_product_in_member_store === true" class="col-12 col-sm-6 col-lg-3 pb-md-3">
                  <post :post="post" :key="post.ID"></post>
                </article>
              </div>
            </div>

          </template>
        </div>

        <div class="no-posts" v-else-if="!loading || error">
          <p class="mb-0" v-html="label.results.none"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import filterlist from './FilterList.vue';
import search from './Search.vue';
import post from './Post.vue';
import Loader from "./Loader";
import searchAPI from '@/js/service/search';

export default {
  name: 'postfilterpage',
  props: {
    filters: {
      type: String,
      required: true
    },
    posts: {
      type: String,
      required: false
    },
    query: {
      type: String,
      required: false
    },
    placeholderText: {
      type: String,
      required: true,
    },
    searchInDefaultPostResults: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchIn: {
      type: Array,
      required: false,
      default: () => ([
        "jobs",
        "events",
        "post",
        "article",
        "product",
        "page"
      ])
    },
    filterOn: {
      type: Array,
      required: false,
      default: () => ([
        'kind',
        'theme',
        'branch',
        'type',
        'tags',
        'categories',
        'province'
      ])
    }
  },
  watch: {
    orderBy() {
      this.sortPosts();
    }
  },
  created() {
    this.postList = JSON.parse(this.posts);

    if (this.isFilterActive()) {
      this.filterPosts();
    } else {
      this.showPosts();
    }
  },

  mounted() {

    const hasOrder = this.filterList.find(filter => {
      return filter.type === 'order';
    });

    if (!hasOrder) {
      this.orderBy = 'desc';

      //check if current url has 'evenementen'
      if (window.location.href.indexOf('evenementen') > -1) {
        this.orderBy = 'asc';
      }
    }
  },
  data() {
    return {
      postToAdd: 8,
      defaultPostAmount: searchLabels.post_amount || 4,
      showFilters: true,
      isShopSearch: this.searchIn && this.searchIn.length === 1 && this.searchIn[0] === 'product',
      filterList: JSON.parse(this.filters), // list of available filters
      postList: [], // list of all post
      postLarge: [],
      orderBy: 'score',
      label: searchLabels.labels,
      posttypes: [
        {
          type: 'post',
          name: searchLabels.labels.widget_titles.posts,
          load: searchLabels.post_amount || 4,
          dot: {
            class: 'bg-purple',
            icon: searchLabels.icons.posts
          }
        },
        {
          type: 'article',
          name: searchLabels.labels.widget_titles.article,
          load: searchLabels.post_amount || 4,
          dot: {
            class: 'bg-purple',
            icon: searchLabels.icons.posts
          }
        },
        {
          type: 'page',
          name: searchLabels.labels.widget_titles.page,
          load: searchLabels.post_amount || 4,
          dot: {
            class: 'bg-purple',
            icon: searchLabels.icons.posts
          }
        },
        {
          type: 'events',
          name: searchLabels.labels.widget_titles.events,
          load: searchLabels.post_amount || 4,
          dot: {
            class: 'bg-blue',
            icon: searchLabels.icons.events
          }
        },
        {
          type: 'jobs',
          name: searchLabels.labels.widget_titles.jobs,
          load: searchLabels.post_amount || 4,
          dot: {
            class: 'bg-yellow',
            icon: searchLabels.icons.jobs
          }
        },
        {
          type: 'product',
          name: searchLabels.labels.widget_titles.products,
          load: searchLabels.post_amount || 4,
          dot: {
            class: 'bg-red',
            icon: searchLabels.icons.products
          }
        },
      ],
      taxMapping: {
        'kind': 'post_object_type',
        'type': 'type',
        'branch': 'branch',
        'theme': 'theme',
        'tag': 'tags',
        'tags': 'tags',
        'category': 'categories',
        'post_object_type': 'kind',
        'kinds': 'kind',
        'province': 'province',
      },
      activeFilters: {}, // filters that are active
      filteredPosts: [], // List of posts whom available by the filter in the activeFilter list
      loading: true,
      error: false,
    }
  },
  computed: {
    // Loop only through postTypes that are searched through
    allowedPostTypes() {
      return this.posttypes.filter(postType => {
        return this.searchIn.includes(postType.type);
      });
    }
  },
  methods: {

    /**
     * Count posts by type
     * @param {string} type String of type.
     **/
    countPosts(type) {
      return this.filteredPosts.reduce(function (n, val) {
        return n + (val.type[0] === type);
      }, 0);
    },

    /**
     * Filter posts by type.
     * @param {string} type String of type.
     **/
    postsByType(type) {

      if (!this.searchIn.includes(type) && this.searchIn.length > 0) {
        return;
      }

      return this.filteredPosts.filter(post => post.type[0] === type);
    },

    /**
     * Check if the filters are active
     * @returns {boolean}
     */
    isFilterActive() {
      return Object.keys(this.activeFilters).length > 0 && this.activeFilters.constructor === Object
    },

    /**
     * Check posts for archive
     * */
    verifyPosts(posts) {
      return posts.reduce((acc, current) => {
        this.postList.forEach(post => {
          if (post.ID === current.id) {
            acc.push(post);
          }
        });
        return acc;
      }, []);
    },

    setNewPosts(posts, isSearching) {

      this.postList = posts;

      if (isSearching) {
        this.error = false;
        this.loading = true;
      } else {
        // Disabled since line below broke the code?
        //  this.postList = this.searchInDefaultPostResults ? this.verifyPosts(posts) : posts;
        this.loading = false;
      }
      this.filterPosts();

      // Re-sync the per-post-type `load` values against the now-current
      // filteredPosts. Without this, a filter click that triggers a
      // server-side re-fetch would leave `load` pegged to the count of the
      // previous (capped) result set, hiding new server-returned matches
      // behind a Load-more button.
      this.syncLoadToFilters();
    },

    /**
     * Set every post type's `load` to either its full filtered count
     * (when a filter is active, so the user sees every match) or to
     * defaultPostAmount (the original "4 per type with Load more"
     * behavior when nothing is filtered).
     */
    syncLoadToFilters() {
      if (this.isFilterActive()) {
        this.posttypes.forEach(type => {
          type.load = this.countPosts(type.type);
        });
      } else {
        this.posttypes.forEach(type => {
          type.load = this.defaultPostAmount;
        });
      }
    },

    showError () {
      this.loading = false;
      this.error = true;

      this.postList = [];
      this.filterPosts();
    },

    // Sort Post on timestamp
    sortPosts() {
      this.filteredPosts.sort((a, b) => {
        if (this.orderBy === 'asc') {
          return a.timestamp - b.timestamp
        }
        if (this.orderBy === 'desc') {
          return b.timestamp - a.timestamp
        }
        if (this.orderBy === 'score') {
          return b.score - a.score
        }
        return (this.orderBy === 'asc') ? a.timestamp - b.timestamp : b.timestamp - a.timestamp;
      });
    },

    /**
     * Show amount of large post.
     */
    showLargePosts() {
      this.postLarge = [];
      if (this.isShopSearch) {
        const length = (this.filteredPosts.length <= 3) ? this.filteredPosts.length : 3;
        if (length > 0) {
          for (let i = 0; i < length; i++) {
            this.postLarge.push(this.filteredPosts.shift());
          }
        }
      }
    },

    /**
     * Show all posts on Initialised
     */
    showPosts() {
      this.filteredPosts = this.postList;
      this.showLargePosts();
      this.sortPosts();
    },

    filterPosts() {

      if(this.postList && this.postList.length > 0) {
        this.filteredPosts = this.postList.filter(post => {

          // Generate Allow array as long as the filters array length
          let allow = new Array();
          for (let i = 0, j = this.filterOn.length; i < j; i++) {
            allow[i] = new Array();
          }

          let finalApproval = [true, true, true];

          for (let tax in this.filterOn) {
            if (this.activeFilters.hasOwnProperty(this.filterOn[tax])
              && this.activeFilters[this.filterOn[tax]].length > 0) {

              this.activeFilters[this.filterOn[tax]].forEach(filter => {
                allow[tax].push(post[this.filterOn[tax]].includes(filter));
              });
            }
          }

          allow.forEach((allowed, index) => {
            if (allowed.length > 0) {
              finalApproval[index] = allowed.includes(true);
            }
          });

          return !finalApproval.includes(false);
        });


        // Loop through posts to modify `events`.
        this.filteredPosts = this.filteredPosts.filter(post => {

          if (-1 !== post.type.indexOf('events') && post.meta) {
            const date = new Date(post.meta.start_date_time.replace(/\s+/g, 'T'));

            // Modify event data.
            post.timestamp = date.getTime();
            post.date = date.toLocaleString(this.getLanguage(), { year: 'numeric', month: 'long', day: 'numeric' });
            post.date_gmt = post.meta.start_date_time.replace(' ', 'T');
          }

          return post;
        });
      }

      this.showLargePosts();
      this.sortPosts();
    },


    getLanguage() {
      // <html lang="..."> is sometimes a bare language code ("nl") and
      // sometimes already a BCP-47 tag with a region ("nl-NL"). The old
      // implementation always appended the uppercased value, which produced
      // an invalid tag like "nl-NL-NL-NL" when WP set the region itself,
      // causing Date.toLocaleString() to throw a RangeError and aborting
      // filterPosts(). Use the value as-is if it already contains a region,
      // otherwise build "xx-XX".
      const lang = (document.documentElement.lang || 'nl').trim();
      if (lang.indexOf('-') !== -1) {
        return lang;
      }
      return `${lang}-${lang.toUpperCase()}`;
    },

    /**
     * @param key: taxonomy name
     * @param value: array of terms
     */
    changeFilterList(key, value) {
      if (value.length === 0) {
        delete this.activeFilters[key];
      } else {
        this.activeFilters[key] = value;
      }
      this.filterPosts();

      // Provide instant client-side feedback against the currently-loaded
      // postList. setNewPosts() will run syncLoadToFilters() again once
      // the server-side fetch returns, which is when the final, complete
      // result set lands.
      this.syncLoadToFilters();

      // Re-fetch from the REST endpoint with the active filters applied
      // server-side. The /wp-json/wp/v2/advanced-search endpoint caps the
      // result set when no filters are sent (to avoid loading every post
      // into memory), so a purely client-side filter would otherwise miss
      // matches that fall outside that cap. Debounced because URL-driven
      // filters can fire several `changeFilterList` calls in quick
      // succession at mount time.
      this.scheduleServerFetch();
    },

    /**
     * Debounce wrapper around fetchFromServer so a flurry of filter
     * activations (e.g. from URL params at mount) collapses to a single
     * request.
     */
    scheduleServerFetch() {
      clearTimeout(this._fetchTimer);
      this._fetchTimer = setTimeout(() => this.fetchFromServer(), 50);
    },

    /**
     * Build the REST args from the current activeFilters and refresh the
     * post list from the server. Mirrors the keys the server understands
     * (see WpRestAPI::relevanssi_search_route_callback's
     * $frontend_filter_map).
     */
    fetchFromServer() {
      const args = {};

      // `type` (post_type) is special — when the user has explicitly
      // filtered post types, send those; otherwise fall back to the
      // searchIn prop so the server still scopes the query correctly.
      if (this.activeFilters.type && this.activeFilters.type.length > 0) {
        args.type = [...this.activeFilters.type];
      } else {
        args.type = [...this.searchIn];
      }

      const taxKeys = ['kind', 'categories', 'tags', 'branch', 'theme', 'province'];
      taxKeys.forEach((key) => {
        if (this.activeFilters[key] && this.activeFilters[key].length > 0) {
          args[key] = [...this.activeFilters[key]];
        }
      });

      // Ask for up to 250 posts per request. Two reasons:
      //   1. With a tax filter active, the server's hard cap is 500
      //      (see relevanssi_search_route_callback), so 250 is comfortably
      //      under that. Without a filter the server clamps this back
      //      down to 50, preserving the original "first 50 newest"
      //      behavior for the unfiltered view.
      //   2. Adding an explicit posts_per_page changes the request URL
      //      and therefore busts any browser/CDN cache that was holding
      //      a stale 50-post response from before the server change went
      //      live.
      // Assigned last so axios serializes it at the tail of the query
      // string (after `type` and any taxonomy filters).
      args.posts_per_page = 250;

      // Don't toggle `loading` on a filter-driven re-fetch: the user is
      // already seeing the client-side filtered subset of postList for
      // instant feedback, and flashing the loader on every checkbox click
      // would be jarring. We only clear `error` so the no-results panel
      // doesn't linger across requests.
      this.error = false;

      searchAPI.get((this.query || '').trim(), args)
        .then((response) => {
          this.setNewPosts(response.data, false);
        })
        .catch(() => {
          this.showError();
        });
    },

    toggleFilterList() {
      this.showFilters = !this.showFilters
    },

    loadMore(postType) {
      postType.load += this.postToAdd;
    }
  },
  components: {
    filterlist,
    post,
    search,
    Loader
  }
}
</script>
